import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAdminDashboardData } from "./DashboardDataAPI";
const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const fetchAdminDashboardDataAsync = createAsyncThunk(
    "AdminDashboardData/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchAdminDashboardData();
            const resp = data?.response
            return resp;
        } catch (error) {
            return rejectWithValue(error.message);

        }
    }
)


const AdminDashboardDataSlice = createSlice({
    name: "AdminDashboardData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAdminDashboardDataAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdminDashboardDataAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(fetchAdminDashboardDataAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
    }
})

export const selectAdminDashboardData = (state) => state.admindashboarddata.data;
export default AdminDashboardDataSlice.reducer;